<template>
  <section v-if="lang[4]">
    <Title :title-name="title.ShareTaxi.titleName" :title-link="title.ShareTaxi.titleLink" />
    <div
      v-if="
        airline &&
        airline.params &&
        airline.params.enable_share_taxi_service &&
        listPax &&
        (!airline.params.pax_per_taxi || listPax.length > airline.params.pax_per_taxi)
      "
      class="container pt-3"
    >
      <span
        class="mt-2 mb-2"
        v-html="replaceStr(lang['matrix_share_taxi'].SFS_LANG_ROW_1, ['<num_people>'], [airline.params.pax_per_taxi])"
      ></span>
      <div class="list-passenger-share-room popupoverflow">
        <table class="tbl-share-room group-tb-0" cellspacing="0" cellpadding="0" border="0">
          <tbody>
            <tr>
              <th class="column-title-notaxi"></th>
              <th v-for="(pax, index) in listPax" :key="index" class="name-room text-center">Taxi {{ index + 1 }}</th>
            </tr>
            <tr v-for="(pax, index) in listPax" :key="index" class="list-passenger text-center">
              <td class="show-name-group">
                <span title="fullname">
                  {{ pax.last_name }}/
                  {{ pax.first_name }}
                  {{ pax.title }}
                </span>
              </td>
              <td v-for="(n, k) in listPax.length" :key="k">
                <label class="el-radio text-center">
                  <input
                    v-model="pax.taxi"
                    type="radio"
                    :name="'taxi-' + pax.passenger_id"
                    class="radioContainer"
                    :value="n"
                    @change="checkPaxOnTaxi(pax.taxi)"
                  />
                  <span class="el-radio-style pull-right"></span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="save-button">
        <button class="btnDefault" @click="saveMatrixTaxi()">Proceed</button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import Title from '@/components/Title/index'

export default {
  name: 'Taxi',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      curPaxInfo: null,
      taxiService: {},
      listPax: []
    }
  },
  computed: {
    ...mapGetters({
      Voucher: 'Taxi/Voucher',
      Services: 'Home/Services',
      PaxsGroup: 'Home/PaxsGroup'
    })
  },
  watch: {
    PaxsGroup: function () {
      this.initData()
    },
    Services: function () {
      this.initData()
    },
    Voucher: function () {
      this.initData()
    }
  },
  created() {
    this.$store.dispatch('Home/getServices')
    this.$store.dispatch('Taxi/getTaxiVoucher')
    this.initData()
  },
  methods: {
    replaceStr,
    initData() {
      let self = this
      if (!_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.Services) && !_.isNull(this.Voucher)) {
        this.listPax = _.clone(this.PaxsGroup)
        this.taxiService = _.find(this.Services, function (service) {
          return service.service_id == 4
        })
        if (!this.taxiService.params && this.taxiService.params && !_.isEmpty(this.taxiService.params.matrix_share_taxi)) {
          this.$router.push({ path: '/service-taxi', query: { secret: this.secret } })
          return
        }
        if (
          !_.isEmpty(this.taxiService) &&
          !_.isEmpty(this.taxiService.params) &&
          !_.isEmpty(this.taxiService.params.matrix_share_taxi)
        ) {
          let matrix = this.taxiService.params.matrix_share_taxi
          if (!_.isEmpty(matrix)) {
            _.forEach(matrix, function (line, key) {
              _.forEach(self.listPax, function (pax) {
                if (line.includes(pax.passenger_id.toString())) {
                  pax.taxi = key + 1
                }
              })
            })
          }
        } else {
          _.forEach(this.listPax, function (pax, key) {
            pax.taxi = key + 1
          })
        }
      }
    },
    saveMatrixTaxi() {
      let self = this
      let dataSend = {
        passenger_ids: [],
        sharetaxi: []
      }
      _.forEach(self.listPax, function (pax, key) {
        dataSend.passenger_ids.push(pax.passenger_id)
      })
      let tmp = _.groupBy(self.listPax, 'taxi')
      _.forEach(tmp, function (value) {
        let matrix = _.map(value, 'passenger_id')
        matrix = matrix.map(String)
        dataSend.sharetaxi.push(matrix)
      })
      self.$store.dispatch('ShareTaxi/storeMatrixShareTaxi', { data: dataSend, secret: self.secret }).then((response) => {
        // check phone number pax by taxi
        if (response) {
          let resume = true
          _.forEach(tmp, function (value) {
            let paxs = _.filter(value, 'phone_number')
            if (_.isEmpty(paxs)) {
              resume = false
            }
          })
          if (resume) {
            self.$router.push({ path: '/taxi-service', query: { secret: self.secret } }).catch(() => {})
          } else {
            self.$router.push({ path: '/update-phone-number', query: { secret: self.secret } }).catch(() => {})
          }
        } else {
          self.$swal('Failed')
        }
      })
    },
    checkPaxOnTaxi(taxi) {
      let self = this
      let maximumPax = self.airline.params.pax_per_taxi || 0
      let paxPerTaxi = _.filter(self.listPax, function (pax) {
        return pax.taxi == taxi
      })
      if (!_.isEmpty(paxPerTaxi) && maximumPax != 0 && paxPerTaxi.length > maximumPax) {
        this.$swal(replaceStr(this.lang['matrix_share_taxi'].SFS_LANG_ROW_2, ['<number>'], [maximumPax]))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-passenger th,
td {
  border: 1px solid black;
}
table,
th,
td {
  padding: 10px;
}
.tbl-share-room {
  position: relative;
  margin-bottom: 15px;
  tr {
    .column-title-notaxi {
      position: sticky;
      left: 0;
    }
    .name-room {
      border-top: 0 !important;
      border-right: 0 !important;
      font-weight: normal;
      color: #71aedc;
    }
    .list-passenger {
      position: relative;
      .show-name-group {
        position: sticky;
        left: 0;
        background: #fff;
        z-index: 1;
      }
    }
    .radioContainer {
      vertical-align: middle;
    }
  }
}
</style>
